/**
 * Client-side feature flags for flowstate-start.
 * Opt-in via VITE_* env vars (defaults off unless noted).
 */

function envFlag(name: string, defaultValue = false): boolean {
  const raw = import.meta.env[name] as string | undefined;
  if (raw === undefined || raw === "") return defaultValue;
  return raw === "true" || raw === "1";
}

/** Experimental Desktop OS shell at /os (src/os/). */
export function isDesktopOsEnabled(): boolean {
  return envFlag("VITE_DESKTOP_OS_ENABLED", false);
}
